'use strict'

import { toastrSettings } from './toastr'
import { pageLoader } from './page-loader.js'
import { navigation } from './navigation.js'
import { respNavigation } from './resp-navigation.js'
import { targetBlank } from './target-blank.js'
import { smoothScroll } from './smooth-scroll.js'
import { coverFull } from './cover-full.js'
import { sliders } from './sliders.js'
import { textTransform } from './text-transform.js'
import { timeline } from './timeline.js'
import { video } from './video.js'
import { accordion } from './accordion.js'
import { animatePattern } from './animate-pattern.js'
import { animatePattern2 } from './animate-pattern-2.js'
import { popup } from './popup.js'
import { scrollAnimations } from './scroll-animation.js'
import { formValidation } from './formValidation'
import officeMap from './map-contact'
import { table } from './table'
import { floatMenu } from './float-menu'
// import { cookie } from './cookie.js'

$(document).ready(function() {
	// Settings first
	toastrSettings()
	smoothScroll()

	const body = $('body')
	// Pages template specific scripts
	if (body.hasClass('page-template-contact')) {
		new officeMap()
	}

	// Commun Functions
	formValidation()
	pageLoader()
	navigation()
	//targetBlank()
	sliders()
	textTransform()
	timeline()
	video()
	floatMenu()
	accordion()
	respNavigation()
	popup()
	// cookie()
	coverFull()
	table()
})

/**
 * Browser compatibility
 *
 * @link https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser/9851769
 */
const isOpera =
	(!!window.opr && !!opr.addons) ||
	!!window.opera ||
	navigator.userAgent.indexOf(' OPR/') >= 0
const isFirefox = typeof InstallTrigger !== 'undefined'
const isSafari =
	/constructor/i.test(window.HTMLElement) ||
	(function(p) {
		return p.toString() === '[object SafariRemoteNotification]'
	})(
		!window['safari'] ||
			(typeof safari !== 'undefined' && safari.pushNotification)
	)
const isIE = /*@cc_on!@*/ !!document.documentMode
const isEdge = !isIE && !!window.StyleMedia
const isChrome = !!window.chrome && !!window.chrome.webstore
const isBlink = (isChrome || isOpera) && !!window.CSS

// Don't run too modern scripts under IE and Edge
if (!isSafari && !isEdge && !isIE) {
	scrollAnimations()
	animatePattern()
	animatePattern2()
}

const body = $('body')
// Add class if is IE in the body
if (isEdge || isIE) {
	body.addClass('is-ie')
} else {
	body.addClass('not-ie')
}
